import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use(
  async (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["x-locale"] = JSON.stringify([
      "vi",
      "en",
      "ja",
      "zh-Hans",
      "zh-Hant",
    ]);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      alert("Bạn đã hết phiên đăng nhập ! Vui lòng đăng nhập lại !");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
